/* unplugin-vue-components disabled */import script from "./WOPerformanceList.vue?vue&type=script&setup=true&lang=js"
export * from "./WOPerformanceList.vue?vue&type=script&setup=true&lang=js"

import "./WOPerformanceList.vue?vue&type=style&index=0&id=6ca4baf7&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ca4baf7"]])

export default __exports__